/* eslint-disable import/prefer-default-export */
export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
